// src/features/roles/api/index.ts
//
// Thin wrapper over the backend /admin/roles endpoints. Backend
// canonical shape is documented in BackendAPI's role.controller.ts.
import apiUtils from '../../../services/api/apiUtils';

export interface Role {
  id: number;
  name: string;
  description: string | null;
  isActive: boolean;
  adminCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface AssignableRole {
  id: number;
  name: string;
  description: string | null;
}

export interface RolePayload {
  name?: string;
  description?: string | null;
  isActive?: boolean;
}

export const rolesApi = {
  list: async (): Promise<Role[]> => {
    const res = await apiUtils.get<Role[]>('/admin/roles');
    return res.data ?? [];
  },
  /// Used by the user-edit modal — trimmed list, hides inactive roles
  /// so a deprecated role can't be re-assigned by mistake.
  assignable: async (): Promise<AssignableRole[]> => {
    const res = await apiUtils.get<AssignableRole[]>('/admin/roles/assignable');
    return res.data ?? [];
  },
  get: async (id: number): Promise<Role | null> => {
    const res = await apiUtils.get<Role>(`/admin/roles/${id}`);
    return res.data ?? null;
  },
  create: async (payload: RolePayload): Promise<Role | null> => {
    const res = await apiUtils.post<Role>('/admin/roles', payload);
    return res.data ?? null;
  },
  update: async (id: number, payload: RolePayload): Promise<Role | null> => {
    const res = await apiUtils.put<Role>(`/admin/roles/${id}`, payload);
    return res.data ?? null;
  },
  remove: async (id: number): Promise<void> => {
    await apiUtils.delete(`/admin/roles/${id}`);
  },
};
